import { delay } from "../client.js";

export const MOCK_ICP = [
  { id: "icp-1", name: "Enterprise Fleet Operator", industry: "Logistics", segment: "Enterprise", fleetSize: "500+", region: "India", status: "active" },
  { id: "icp-2", name: "EV Rental Startup", industry: "Mobility", segment: "Growth", fleetSize: "50–200", region: "APAC", status: "active" },
  { id: "icp-3", name: "OEM Telematics Partner", industry: "Automotive", segment: "Strategic", fleetSize: "1000+", region: "Global", status: "active" },
  { id: "icp-4", name: "Municipal Transit", industry: "Public Transport", segment: "Government", fleetSize: "200–500", region: "India", status: "draft" },
];

export async function listIcp() {
  await delay(140);
  return [...MOCK_ICP];
}
